import hashString from "common/utils/hashString";
import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_50: DocMigration = {
  maxSchemaVersion: "0.0.50",
  apply(json: any) {
    if (json.settings) {
      let nameCounter: number = 0;

      let columnTable = {};
      let columnSettingsId = uid();
      const hashToUidTable: { [hash: string]: string } = {};

      for (const settingsId in json.settings) {
        const table = json.settings[settingsId];
        if (table.type !== "COLUMN_SETTINGS") {
          continue;
        }
        for (const columnId in table.columnTable) {
          const column = table.columnTable[columnId];
          const sections = column.sections;
          const hash = makeColumnSectionsHash(sections);
          hashToUidTable[hash] = columnId;
        }
        columnTable = table.columnTable;
        columnSettingsId = settingsId;
      }

      for (const tableId in json.settings) {
        const table = json.settings[tableId];
        if (table.type === "PORCH_SETTINGS") {
          if (table.columnSlices) {
            const sections = table.columnSlices;
            const hash = makeColumnSectionsHash(sections);
            const uidString = hashToUidTable[hash];
            if (uidString) {
              table.columnId = uidString;
            } else {
              const newUid = uid();
              nameCounter++;
              hashToUidTable[hash] = newUid;
              columnTable[newUid] = {
                entityType: "COLUMN" as any,
                name: `Column ${nameCounter}`,
                sections: table.columnSlices,
                elevationNoteEnabled: false,
                elevationNote: "",
                bomDescription: "",
              };
              table.columnId = newUid;
            }
            delete table.columnSlices;
          }
          if (table.topOfBeamHeightOffset) {
            table.topOfHeaderHeightOffset = table.topOfBeamHeightOffset;
            delete table.topOfBeamHeightOffset;
          }
          if (table.beamDepth) {
            table.headerDepth = table.beamDepth;
            delete table.beamDepth;
          }
          if (table.internalBeamStructureWidth) {
            table.internalHeaderStructureWidth = table.internalBeamStructureWidth;
            delete table.internalBeamStructureWidth;
          }
        }
      }

      if (Object.keys(columnTable).length > 0) {
        json.settings[columnSettingsId] = {
          type: "COLUMN_SETTINGS",
          columnTable,
        };
        if (!json.settingsOverride) {
          json.settingsOverride = {};
        }
        json.settingsOverride["column"] = columnSettingsId;
      }
    }
    return json;
  },
};

function makeColumnSectionsHash(sections: any[]): string {
  let hashSource = "";
  for (const section of sections) {
    const sectionHash = `|${section.height}|${section.paletteId}|${section.width}|${section.taper || false}`;
    hashSource = hashSource + sectionHash;
  }
  return hashString(hashSource).toString();
}

export default migration_0_0_50;
